import React from 'react';

import classNames from 'classnames';

import * as styles from './no-image.module.css';
import { AlmaLink } from '../../../alma-link';
import { PortableText } from '../../../portableText';

export function NoImageHero({
  _rawHeroCopy,
  backgroundColor,
  ctas,
  fadeEffects,
  horizontalAlignment,
  verticalAlignment,
  verticalPadding
}) {
  // content padding
  const modulePaddingTop = verticalPadding?.modulePaddingTop;
  const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

  // fade effects
  const enableFadeEffect = fadeEffects?.enableFadeEffect;
  const fadeEffectDirection = fadeEffects?.fadeEffectDirection;

  return (
    <div
      className={
        classNames(
          backgroundColor && `b${backgroundColor}`,
          styles.moduleContainer
        )
      }
    >
      <div
        className={
          classNames(
            enableFadeEffect && 'reveal',
            fadeEffectDirection && fadeEffectDirection,
            styles.contentContainer,
            styles[verticalAlignment],
            styles[horizontalAlignment],
            modulePaddingTop,
            modulePaddingBottom
          )
        }
      >
        {_rawHeroCopy && (
          <PortableText blocks={_rawHeroCopy} />
        )}
        {ctas && (
          <div className={styles.ctaContainer}>
            {ctas.map((cta, key) => {
              return (
                <AlmaLink
                  cta={cta}
                  key={key}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
